import React from "react";
import Skills from "./Skills";
import About from "./About";
import skillList from "./data/skills.json";
import { getSkillsYears, getMaxYears } from "./Utility";

const Home = () => {
  const arr = getSkillsYears(skillList);
  const maxYears = getMaxYears(arr);
  const views = {
    DESKTOP: "desktop",
    MOBILE: "mobile"
  };
  return (
    <div className="container app--container">
      <div className="profile-pic--container">
        <div className="home">
          <img
            className="profile-pic"
            src={require("./assets/grayed.jpg")}
            alt="eds-profile-pic"
          />
        </div>
      </div>

      <div className="contextHolder">
        <div className="main-content--container desktop-view">
          <About view={views.DESKTOP} />
          <hr />
          <Skills maxYears={maxYears} view={views.DESKTOP} />
        </div>
        <div className="main-content--container mobile-view">
          <About view={views.MOBILE} />
          <Skills maxYears={maxYears} view={views.MOBILE} />
        </div>
      </div>
    </div>
  );
};

export { Home };
